const ADD_DESIGNATION = "ADD_DESIGNATION";
const UPDATE_DESIGNATION = "ADD_DESIGNATION";
const DELETE_DESIGNATION = "DELETE_DESIGNATION";
const DESIGNATIONS = "DESIGNATIONS";
const ADD_DESIGNATION_ERROR = "ADD_DESIGNATION_ERROR";
const DESIGNATION_DETAILS = "DESIGNATION_DETAILS";

export {
	ADD_DESIGNATION,
	UPDATE_DESIGNATION,
	DELETE_DESIGNATION,
	DESIGNATIONS,
	ADD_DESIGNATION_ERROR,
	DESIGNATION_DETAILS,
};
